import { render, staticRenderFns } from "./userExtraConfig.vue?vue&type=template&id=f7006ff8&scoped=true"
import script from "./userExtraConfig.vue?vue&type=script&lang=js"
export * from "./userExtraConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7006ff8",
  null
  
)

export default component.exports